export function sumObjectValues(obj: Record<string, number>): number {
	return Object.values(obj).reduce((a: number, b: number) => a + b, 0);
}

export function sumArray(array, property) {
	if (array && array.length > 0) {
		return array.reduce((total, current) => total + current[property], 0);
	}
	return 0;
}
